import React from "react";
import { List, SelectAll } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";

import { selectCurrentAccount, useGetAccountModulesQuery } from "fond/api";
import PropertiesPanel from "fond/project/featureProperties/PropertiesPanel";
import PropertiesPanelEdit from "fond/project/featureProperties/PropertiesPanelEdit";
import { useAppSelector } from "fond/utils/hooks";
import { accountModuleCheck, Actions } from "fond/utils/permissions";

import { ITabProps } from "./factory";

export const Widget: React.FC<ITabProps> = () => {
  const { selectedFeature, editMode } = useAppSelector((state) => state.project);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { data: accountModules } = useGetAccountModulesQuery(currentAccount?.ID ?? skipToken);
  const hasISGDesignModule = accountModuleCheck(accountModules, Actions.ISG_DESIGN_ADD);

  if (editMode === "edit" && hasISGDesignModule) {
    return <PropertiesPanelEdit />;
  }

  if (!selectedFeature) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center">
        <Box display="flex" flexDirection="column" alignItems="center">
          <SelectAll color="action" sx={{ mb: 2 }} />
          <Typography variant="body3">Select a feature to view</Typography>
        </Box>
      </Box>
    );
  }

  return <PropertiesPanel />;
};

export const Icon: React.FC<ITabProps> = () => (
  <Tooltip title="Properties" arrow placement="right">
    <List />
  </Tooltip>
);
